function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 17.494C0 7.827 7.96 0 17.79 0c9.83 0 17.79 7.827 17.79 17.494s-7.96 17.494-17.79 17.494C7.96 34.988 0 27.16 0 17.494",
  fill: "#FEFEFE"
}), React.createElement("path", {
  d: "M0 17.494C0 7.827 7.96 0 17.79 0c9.83 0 17.79 7.827 17.79 17.494s-7.96 17.494-17.79 17.494C7.96 34.988 0 27.16 0 17.494z",
  stroke: "#FEFEFE",
  strokeWidth: 0.005
}), React.createElement("path", {
  d: "M32.677 17.494C32.677 7.827 40.636 0 50.467 0c9.83 0 17.789 7.827 17.789 17.494s-7.96 17.494-17.79 17.494c-9.83 0-17.79-7.827-17.79-17.494",
  fill: "#FEFEFE"
}), React.createElement("path", {
  d: "M32.677 17.494C32.677 7.827 40.636 0 50.467 0c9.83 0 17.789 7.827 17.789 17.494s-7.96 17.494-17.79 17.494c-9.83 0-17.79-7.827-17.79-17.494z",
  stroke: "#FEFEFE",
  strokeWidth: 0.005
}), React.createElement("path", {
  d: "M65.353 17.494C65.353 7.827 73.312 0 83.143 0c9.83 0 17.79 7.827 17.79 17.494s-7.96 17.494-17.79 17.494c-9.831 0-17.79-7.827-17.79-17.494",
  fill: "#FEFEFE"
}), React.createElement("path", {
  d: "M65.353 17.494C65.353 7.827 73.312 0 83.143 0c9.83 0 17.79 7.827 17.79 17.494s-7.96 17.494-17.79 17.494c-9.831 0-17.79-7.827-17.79-17.494z",
  stroke: "#FEFEFE",
  strokeWidth: 0.005
}), React.createElement("path", {
  d: "M34.15 17.44C34.15 8.52 41.494 1.3 50.565 1.3c9.071 0 16.415 7.222 16.415 16.142 0 8.92-7.344 16.142-16.415 16.142-9.071 0-16.415-7.222-16.415-16.142",
  fill: "#CE2A35"
}), React.createElement("path", {
  d: "M34.15 17.44C34.15 8.52 41.494 1.3 50.565 1.3c9.071 0 16.415 7.222 16.415 16.142 0 8.92-7.344 16.142-16.415 16.142-9.071 0-16.415-7.222-16.415-16.142z"
}), React.createElement("path", {
  d: "M1.387 17.44C1.387 8.52 8.73 1.3 17.802 1.3c9.07 0 16.415 7.222 16.415 16.142 0 8.92-7.344 16.142-16.415 16.142-9.071 0-16.415-7.222-16.415-16.142",
  fill: "#CE2A35"
}), React.createElement("path", {
  d: "M1.387 17.44C1.387 8.52 8.73 1.3 17.802 1.3c9.07 0 16.415 7.222 16.415 16.142 0 8.92-7.344 16.142-16.415 16.142-9.071 0-16.415-7.222-16.415-16.142z"
}), React.createElement("path", {
  d: "M41.175 20.491c.336 3.825 3.823 5.111 7.328 5.194 5.516.115 9.423-1.435 9.607-4.6.218-3.529-3.202-4.848-6.12-5.524-2.565-.577-3.37-.874-3.253-1.83.1-.99 1.66-1.369 2.868-1.369.872 0 1.525.248 1.995.479.369.18.62.527.704 1.253h5.164c.151-3.463-3.906-4.634-7.914-4.634-3.772 0-7.88 1.352-8.098 4.996-.134 2.375 1.81 3.331 4.108 4.056 1.928.578 5.633.973 5.55 2.573-.067.874-.956 1.45-2.918 1.55-1.727.066-3.454-.38-3.823-2.144h-5.198z",
  fill: "#FEFEFE"
}), React.createElement("path", {
  d: "M41.175 20.491c.336 3.825 3.823 5.111 7.328 5.194 5.516.115 9.423-1.435 9.607-4.6.218-3.529-3.202-4.848-6.12-5.524-2.565-.577-3.37-.874-3.253-1.83.1-.99 1.66-1.369 2.868-1.369.872 0 1.525.248 1.995.479.369.18.62.527.704 1.253h5.164c.151-3.463-3.906-4.634-7.914-4.634-3.772 0-7.88 1.352-8.098 4.996-.134 2.375 1.81 3.331 4.108 4.056 1.928.578 5.633.973 5.55 2.573-.067.874-.956 1.45-2.918 1.55-1.727.066-3.454-.38-3.823-2.144h-5.198z",
  stroke: "#FEFEFE",
  strokeWidth: 0.006
}), React.createElement("path", {
  d: "M66.848 17.44c0-8.92 7.344-16.141 16.415-16.141 9.071 0 16.415 7.222 16.415 16.142 0 8.92-7.344 16.142-16.415 16.142-9.07 0-16.415-7.222-16.415-16.142",
  fill: "#CE2A35"
}), React.createElement("path", {
  d: "M66.848 17.44c0-8.92 7.344-16.141 16.415-16.141 9.071 0 16.415 7.222 16.415 16.142 0 8.92-7.344 16.142-16.415 16.142-9.07 0-16.415-7.222-16.415-16.142z"
}), React.createElement("path", {
  d: "M73.874 20.491c.335 3.825 3.823 5.111 7.327 5.194 5.516.115 9.423-1.435 9.624-4.6.201-3.529-3.219-4.848-6.137-5.524-2.565-.577-3.37-.874-3.252-1.83.117-.99 1.66-1.369 2.884-1.369.855 0 1.509.248 1.978.479.37.18.637.527.704 1.253h5.165c.15-3.463-3.907-4.634-7.915-4.634-3.772 0-7.88 1.352-8.098 4.996-.134 2.375 1.81 3.331 4.125 4.056 1.911.578 5.617.973 5.533 2.573-.05.874-.939 1.45-2.918 1.55-1.727.066-3.437-.38-3.823-2.144h-5.197z",
  fill: "#FEFEFE"
}), React.createElement("path", {
  d: "M73.874 20.491c.335 3.825 3.823 5.111 7.327 5.194 5.516.115 9.423-1.435 9.624-4.6.201-3.529-3.219-4.848-6.137-5.524-2.565-.577-3.37-.874-3.252-1.83.117-.99 1.66-1.369 2.884-1.369.855 0 1.509.248 1.978.479.37.18.637.527.704 1.253h5.165c.15-3.463-3.907-4.634-7.915-4.634-3.772 0-7.88 1.352-8.098 4.996-.134 2.375 1.81 3.331 4.125 4.056 1.911.578 5.617.973 5.533 2.573-.05.874-.939 1.45-2.918 1.55-1.727.066-3.437-.38-3.823-2.144h-5.197z",
  stroke: "#FEFEFE",
  strokeWidth: 0.006
}), React.createElement("path", {
  d: "M8.496 25.421h12.19c5.986 0 8.232-6.463 2.917-8.096v-.066c2.18-.412 4.058-1.714 4.192-3.825.1-1.748-.821-3.61-5.919-3.61h-8.752L8.496 25.42z",
  fill: "#FEFEFE"
}), React.createElement("path", {
  d: "M8.496 25.421h12.19c5.986 0 8.232-6.463 2.917-8.096v-.066c2.18-.412 4.058-1.714 4.192-3.825.1-1.748-.821-3.61-5.919-3.61h-8.752L8.496 25.42z",
  stroke: "#FEFEFE",
  strokeWidth: 0.006
}), React.createElement("path", {
  d: "M17.316 13.022h3.202c2.934.05 2.482 3.215-.654 3.034l-3.47.016.922-3.05z",
  fill: "#D8555D"
}), React.createElement("path", {
  d: "M17.316 13.022h3.202c2.934.05 2.482 3.215-.654 3.034l-3.47.016.922-3.05z",
  stroke: "#E0393D",
  strokeWidth: 0.006
}), React.createElement("path", {
  d: "M15.454 19.024h3.454c3.203.066 3.572 3.314-.687 3.314h-3.74l.973-3.314z",
  fill: "#D8555D"
}), React.createElement("path", {
  d: "M15.454 19.024h3.454c3.203.066 3.572 3.314-.687 3.314h-3.74l.973-3.314z",
  stroke: "#E0393D",
  strokeWidth: 0.006
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 101 35",
    width: "1em",
    height: "1em"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/bss-logo.128bc8ce.svg";
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/assets/svgs/bss-logo.svg